import { MutationOptions, useMutation } from '@tanstack/react-query';
import { jobAdjustmentService } from '../jobAdjustmentService';

export const useSkipJobAdjustment = (options?: MutationOptions<any, Error, any, unknown>) => {
  return useMutation<any, Error, any>({
    mutationFn: async (payload: any) => {
      return jobAdjustmentService.skipJobAdjustment(payload);
    },
    ...options,
  });
};
